import { Link } from '@/core'
import { AuthContent } from '@c/auth-app/auth-content'
import { useTranslation } from 'react-i18next'
import styles from './style.module.styl'

export const ConfirmEmailSuccessPage = () => {
  const { t } = useTranslation()

  return (
    <AuthContent
      title={t('auth.confirmEmailSuccessPage.title')}
      extra={
        <Link name="login">
          {t('auth.confirmEmailSuccessPage.links.return_login')}
        </Link>
      }
    >
      <p className={styles.detail}>
        {t('auth.confirmEmailSuccessPage.message')}
      </p>
    </AuthContent>
  )
}
